import { useCollapseContext } from '../context/collapse-context';

export const CollapseToggler = (props) => {
    const { children, ...rest } = props;

    const { expanded, setExpanded } = useCollapseContext();

    return (
        <button {...rest} type="button" aria-expanded={expanded} onClick={() => setExpanded((prev) => !prev)}>
            {children}
        </button>
    );
};

export default CollapseToggler;
